import { TouchGestureType } from "./map.inputs.interfaces.touch";
export class InpustNavigationControllerOptions {
}
InpustNavigationControllerOptions.DEFAULT_ZOOM_INCREMENT = 0.1;
InpustNavigationControllerOptions.DEFAULT_TOUCH_ZOOM_INCREMENT = 0.05;
InpustNavigationControllerOptions.DEFAULT_INVERT_Y = false;
InpustNavigationControllerOptions.DEFAULT_INVERT_Z = false;
InpustNavigationControllerOptions.DEFAULT_ROTATE_FACTOR = 1;
InpustNavigationControllerOptions.DEFAULT_TRANSLATE_FACTOR = 1;
InpustNavigationControllerOptions.DEFAULT_ZOOM_FACTOR = 1;
InpustNavigationControllerOptions.DEFAULT_OPTIONS = {
    zoomIncrement: InpustNavigationControllerOptions.DEFAULT_ZOOM_INCREMENT,
    touchZoomIncrement: InpustNavigationControllerOptions.DEFAULT_TOUCH_ZOOM_INCREMENT,
    invertZ: InpustNavigationControllerOptions.DEFAULT_INVERT_Z,
    invertY: InpustNavigationControllerOptions.DEFAULT_INVERT_Y,
};
export class InputsNavigationController {
    constructor(source, target, options) {
        this._onDragObserver = null;
        this._onWheelObserver = null;
        this._onTouchObserver = null;
        this._onDrag = (event) => {
            switch (event.type) {
                case "drag": {
                    switch (event.button) {
                        case 0: {
                            if (event.deltaX || event.deltaY) {
                                const translateFactor = this._options.translateFactor ?? InpustNavigationControllerOptions?.DEFAULT_TRANSLATE_FACTOR;
                                const invertY = this._options.invertY ?? InpustNavigationControllerOptions?.DEFAULT_INVERT_Y;
                                this._target.translateUnitsMap(-event.deltaX * translateFactor, (invertY ? event.deltaY : -event.deltaY) * translateFactor);
                            }
                            break;
                        }
                        case 2: {
                            if (event.deltaX) {
                                const rotateFactor = this._options.rotateFactor ?? InpustNavigationControllerOptions?.DEFAULT_ROTATE_FACTOR;
                                this._target.rotateMap(Math.sign(event.deltaX) * Math.hypot(event.deltaX, event.deltaY) * rotateFactor);
                            }
                            break;
                        }
                    }
                    break;
                }
            }
        };
        this._onWheel = (event) => {
            const zoomFactor = this._options.zoomFactor ?? InpustNavigationControllerOptions?.DEFAULT_ZOOM_FACTOR;
            const delta = Math.sign(event.deltaY) * (this._options.zoomIncrement ?? Math.abs(event.deltaY)) * zoomFactor;
            this._target.zoomMap(this._options.invertZ ? delta : -delta);
        };
        this._onTouch = (event) => {
            switch (event.type) {
                case TouchGestureType.Drag: {
                    const translateFactor = this._options.translateFactor ?? InpustNavigationControllerOptions?.DEFAULT_TRANSLATE_FACTOR;
                    const invertY = this._options.invertY ?? InpustNavigationControllerOptions?.DEFAULT_INVERT_Y;
                    this._target.translateUnitsMap(-event.deltaX * translateFactor, (invertY ? event.deltaY : -event.deltaY) * translateFactor);
                    break;
                }
                case TouchGestureType.Pinch: {
                    const zoomFactor = this._options.zoomFactor ?? InpustNavigationControllerOptions?.DEFAULT_ZOOM_FACTOR;
                    const delta = Math.sign(event.scale) * (this._options.touchZoomIncrement ?? Math.abs(event.scale)) * zoomFactor;
                    this._target.zoomMap(this._options.invertZ ? -delta : delta);
                    break;
                }
                case TouchGestureType.Rotate: {
                    const rotateFactor = this._options.rotateFactor ?? InpustNavigationControllerOptions?.DEFAULT_ROTATE_FACTOR;
                    this._target.rotateMap(event.angle * rotateFactor);
                    break;
                }
            }
        };
        this._source = source;
        this._target = target;
        this._options = options ?? InpustNavigationControllerOptions.DEFAULT_OPTIONS;
        this._attachSource(this._source);
    }
    dispose() {
        this._detachSource();
    }
    _attachSource(source) {
        this._onDragObserver = source.onDragObservable.add(this._onDrag);
        this._onWheelObserver = source.onWheelObservable.add(this._onWheel);
        this._onTouchObserver = source.onTouchObservable.add(this._onTouch);
    }
    _detachSource() {
        this._onDragObserver?.disconnect();
        this._onWheelObserver?.disconnect();
        this._onDragObserver = null;
        this._onWheelObserver = null;
    }
}
//# sourceMappingURL=map.inputs.controller.navigation.js.map